import formatMediaObject from '../utils/formatters/format-media-object';

/**
 * Format the dietary labels data for display.
 *
 * @param {object} context
 * @param {Array} dietaryLabels
 *
 * @returns {{image: {src: string, alt: string}, text: string, value: string}[]}
 */
export const formatDietaryLabels = (context, dietaryLabels = []) => {
    return dietaryLabels.map((dietaryLabel) => ({
        value: dietaryLabel.key,
        image: formatMediaObject
            .call(context, dietaryLabel.icon),
        text: dietaryLabel.name,
        subtext: dietaryLabel.description,
    }));
};
